import { Text, View, XStack } from "tamagui";
import {
  NavigationProp,
  StackActions,
  useNavigation,
} from "@react-navigation/native";
import { CloseIcon } from "../../../../components/design-system/icons";

import { useAtomValue } from "jotai";

import { Loader } from "../../../../components/design-system/Loader";

import { currentUserAtom } from "../../../../../atoms/global";

import { useSafeAreaInsets } from "react-native-safe-area-context";
import { HeaderButton } from "../../../../components/design-system/Button/HeaderButton";
import { BaseNavigatorParamList } from "../../../../navigators/BaseNavigator";

import { useMutation } from "@tanstack/react-query";
import { api } from "../../../../../lib/api";
import { RideForm } from "../../../../components/RideForm/RideForm";
import { Ride } from "../../../../components/RideForm/types";

export const CreateRideForm = () => {
  const currentUser = useAtomValue(currentUserAtom);

  const navigation = useNavigation<NavigationProp<BaseNavigatorParamList>>();

  const { mutateAsync: createRide, isPending } = useMutation({
    mutationFn: (ride: Ride) =>
      api.post<{ event_id: string }>("/api/v1/events", {
        name: ride.name,
        description: ride.description,
        image_url: null,
        type: "ClubRide",
        date: ride.date,
        time: ride.time,
        location: ride?.location ?? "",
        groups: ride.groups,
        host_id: currentUser?.id ?? "",
        terrain: ride.terrain,
        route_id: ride?.route?.id ?? null,
        visibility: ride?.visibility,
        recipient_ids: ride?.invited_users?.map((i) => i.id) ?? [],
      }),
    onSuccess: (data: any) => {
      const eventId = data?.event?.id;
      if (eventId) {
        navigation.dispatch(StackActions.replace("Home"));
        setTimeout(() => {
          navigation.navigate("EventDetail", { eventId, autoOpenShare: true });
        }, 200);
      }
    },
  });

  const onSubmit = (ride: Ride) => {
    createRide(ride);
  };

  const { top } = useSafeAreaInsets();

  return (
    <View flex={1} bg="$brandParchment" paddingTop={top}>
      <View px="$4" pb="$4" justifyContent="flex-start" alignItems="flex-start">
        <XStack justifyContent="space-between" w="100%" alignItems="center">
          <View>
            <HeaderButton onPress={() => navigation.goBack()}>
              <CloseIcon color="black" width={16} height={16} />
            </HeaderButton>
          </View>
          <View justifyContent="flex-end" alignItems="flex-end">
            <Text fontSize={16}>Rides by Breakfast Club</Text>
          </View>
        </XStack>
      </View>
      {isPending ? <Loader /> : null}
      <RideForm currentUserId={currentUser?.id ?? ""} handleSubmit={onSubmit} />
    </View>
  );
};
